// Important config will be deleted once typography is consistent across FP

export const FPTypography = {
  fontFamilyHeader: '"Kanit", sans-serif !important',
  fontFamilyContent: '"Roboto", sans-serif !important',
  fontWeight: {
    light: '300 !important',
    regular: '400 !important',
    medium: '500 !important',
    semiBold: '600 important',
    bold: '700 !important'
  }
};
